import React from 'react'
import styles from './Hero.module.scss'
import { Container } from 'components/common/Containers'
import classNames from 'classnames'

interface Props {
  className?: string
}

const Hero: React.FC<Props> = ({ children, className }) => {
  return (
    <section className={classNames(styles.container, className)}>
      <Container>{children}</Container>
    </section>
  )
}

export default Hero
